// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2100;
}

.scm-modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: scm-slideUp 0.3s ease;
}

.scm-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.scm-modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #002FA7;
  margin: 0;
}

.scm-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #64748b;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
}

.scm-modal-close:hover {
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
}

.scm-modal-body {
  flex: 1 1;
  padding: 20px 24px;
  overflow-y: auto;
}

.scm-search-container {
  margin-bottom: 16px;
}

.scm-search-input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.scm-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.scm-staffs-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.scm-staff-item {
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.scm-staff-item:hover {
  background-color: #f1f5f9;
  border-color: #002FA7;
}

.scm-staff-item-current {
  background-color: #eef2ff;
  border-color: #002FA7;
}

.scm-staff-name {
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 4px;
}

.scm-staff-email {
  font-size: 12px;
  color: #64748b;
}

.scm-loading, .scm-error, .scm-empty {
  text-align: center;
  padding: 32px;
  color: #64748b;
}

.scm-error {
  color: #ef4444;
}

@keyframes scm-slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/SelectCuratorModalStyle.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C","sourcesContent":[".scm-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2100;\n}\n\n.scm-modal-content {\n  background: white;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  animation: scm-slideUp 0.3s ease;\n}\n\n.scm-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.scm-modal-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0;\n}\n\n.scm-modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.scm-modal-close:hover {\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n}\n\n.scm-modal-body {\n  flex: 1;\n  padding: 20px 24px;\n  overflow-y: auto;\n}\n\n.scm-search-container {\n  margin-bottom: 16px;\n}\n\n.scm-search-input {\n  width: 100%;\n  padding: 10px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.scm-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.scm-staffs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.scm-staff-item {\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.scm-staff-item:hover {\n  background-color: #f1f5f9;\n  border-color: #002FA7;\n}\n\n.scm-staff-item-current {\n  background-color: #eef2ff;\n  border-color: #002FA7;\n}\n\n.scm-staff-name {\n  font-weight: 500;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.scm-staff-email {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.scm-loading, .scm-error, .scm-empty {\n  text-align: center;\n  padding: 32px;\n  color: #64748b;\n}\n\n.scm-error {\n  color: #ef4444;\n}\n\n@keyframes scm-slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
